const stats = [
  { value: "20000+", label: "影视资源" },
  { value: "每日", label: "持续更新" },
  { value: "全端", label: "多设备观看" },
  { value: "高清", label: "画质保障" },
];

const features = [
  {
    icon: "ri-database-2-line",
    title: "海量影库",
    desc: "汇聚电影、电视剧等多类型影视资源，分类清晰，查找便捷。",
  },
  {
    icon: "ri-refresh-line",
    title: "极速更新",
    desc: "热播内容每日同步更新，追剧不等待，第一时间掌握最新动态。",
  },
  {
    icon: "ri-magic-line",
    title: "智能推荐",
    desc: "基于类型与热度自动关联相似作品，帮您轻松发现下一部心头好。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-label font-semibold">
          <i className="ri-shield-check-line"></i>
          关于 51无敌电影网
        </span>
        <h2 className="mt-4 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          一个为影视爱好者打造的观影入口
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          51无敌电影网聚焦最新电影与电视剧的在线播放与信息展示，
          为追剧党与影视爱好者提供便捷的分类浏览、快速筛选与智能推荐。
          我们坚持内容真实、信息完整，让每一次浏览都更省心、每一部好片都不被错过。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-lg bg-background-50 border border-background-200 p-5 text-center"
          >
            <p className="text-xl md:text-2xl font-heading font-bold text-primary-600">
              {stat.value}
            </p>
            <p className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="rounded-lg bg-background-50 border border-background-200 p-6"
          >
            <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
              <i className={`${feature.icon} text-xl`}></i>
            </span>
            <h3 className="mt-4 text-base font-heading font-semibold text-foreground-900">
              {feature.title}
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}